/**
 * Compares two version strings and determines if the first version is newer than the second.
 * @param v1 The first version string to compare
 * @param v2 The second version string to compare
 * @returns True if v1 is newer than v2, false otherwise
 */
export const isVersionNew = (v1: string, v2: string): boolean => {
  // Check if either version contains non-numeric characters (excluding dots)
  const hasWords = /[^0-9.]/.test(v1) || /[^0-9.]/.test(v2);
  if (hasWords) return false;

  // Split versions into parts
  const v1Parts = v1.split(".").map(Number);
  const v2Parts = v2.split(".").map(Number);

  // Compare each part
  for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
    const part1 = v1Parts[i] || 0; // Use 0 if part doesn't exist
    const part2 = v2Parts[i] || 0; // Use 0 if part doesn't exist

    // If parts are different, return true if v1 is newer
    if (part1 !== part2) {
      return part1 > part2;
    }
  }

  // If all parts are equal, versions are equal
  return false;
};
